import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        lxr: null,
        insert: false,
        update: false,
        loading: false
    },
    getters: {

    },
    mutations: {
        set(state, lxr){
            state.lxr = lxr
            if (lxr)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
        }
    },
    actions: {
        async find(store){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/Oryx/TrackingParameters/Find")
            .then(response => {
                let lxr = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", lxr)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
            return true
        },
        save(store){
            if (store.state.update){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Oryx/TrackingParameters/Insert", store.state.lxr )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Oryx/TrackingParameters/Update", store.state.lxr )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete("/Oryx/TrackingParameters/Delete")
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
    }
}
